import React from 'react';
import { ExternalLink } from 'lucide-react';
import { companyInfo, quickLinks } from '../../data/mockData';

export const FooterLinks = () => (
  <div className="footer-section">
    <h4>Quick Links</h4>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      {quickLinks.slice(0, 5).map((link) => (
        <button
          key={link.href}
          onClick={() => {
            const el = document.getElementById(link.href.replace('#', ''));
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }}
          className="footer-link"
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, textAlign: 'left', fontSize: '0.9rem' }}
        >
          {link.title}
        </button>
      ))}
      <a
        href={companyInfo.googleCalendarLink}
        target="_blank"
        rel="noopener noreferrer"
        className="footer-link"
        style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', fontSize: '0.9rem' }}
      >
        Schedule a Consultation <ExternalLink size={12} />
      </a>
    </div>
  </div>
);

export const FooterServices = () => (
  <div className="footer-section">
    <h4>Our Services</h4>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      <a href="#services" className="footer-link">Portfolio Review</a>
      <a href="#services" className="footer-link">Investment Review</a>
      <a href="#services" className="footer-link">Policy Review</a>
      <a href="#services" className="footer-link">Free Financial Health-Checkup</a>
      <a href="#services" className="footer-link">Retirement Planning</a>
      <a href="#services" className="footer-link">Tax Planning & Filing</a>
    </div>
  </div>
);
